import type { Text_Highlighter } from "~/core";

export const isTextHighlighter = (item: unknown): item is Text_Highlighter => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "text_highlighter"
  );
};
